import {
  typographyStyles,
  constants,
  mediaQueryStyles,
} from "@newsela/angelou";

const { textSObj } = typographyStyles;
const { ui } = constants.colors;
const { mediaQuery: breakpoint } = mediaQueryStyles;

export const fieldWrapperCss = {
  display: "flex",
  alignItems: "flex-end",
};

export const copyLabelCss = {
  lineHeight: 0,
};

export const copyUnderInputCss = {
  display: "none",
};

export const copyButtonCss = {
  borderColor: ui.neutral[500],
  marginLeft: "0.5em",
};

export const copyButtonIconCss = {
  root: {
    path: {
      strokeWidth: 2,
    },
  },
};

export const sectionDividerCss = {
  display: "flex",
  flexDirection: "row",
  strong: {
    ...textSObj,
    color: ui.neutral[400],
  },
  hr: {
    flex: 1,
    alignSelf: "center",
    border: "none",
    borderBottom: `1px solid ${ui.neutral[100]}`,
    marginLeft: 15,
  },
};

export const modalRootCss = {
  zIndex: 15,
};

export const modalContentWrapperCss = {
  [breakpoint.downTo(constants.breakpoints.BreakpointNames.xs)]: {
    height: "fit-content",
  },
};

export const modalscrollableBodyCss = {
  display: "flex",
  flexDirection: "column",
  gap: 15,
};

export const modalFooterCss = {
  display: "none",
};
